import React from "react";
import CustomPhoneInput from "../../shared/CustomPhoneInput";

const FormInput = React.forwardRef(
  (
    {
      label,
      type = "text",
      placeholder,
      value = "",
      className = "",
      width = "full",
      required = false,
      error = "",
      name = "",
      autoComplete = "on",
      onChange = () => {},
      ...props
    },
    ref,
  ) => {
    const sharedClassName = `${width === "full" ? "w-full" : "w-auto"} px-4 py-2 rounded-md bg-[#EFF5F5] disabled:opacity-50
    ${
      error
        ? "border border-red-500 text-red-600 focus:ring-red-400 has-[input:focus]:ring-red-400"
        : "border border-[#EDF1F2] text-[#303030] focus:ring-green-500 has-[input:focus]:ring-green-500"
    }
    focus:outline-none focus:ring-2 has-[.PhoneInputInput:focus]:ring-2 transition-colors
  `;

    return (
      <div className={`${className} w-full`}>
        {label && (
          <label className="block text-gray-700 mb-2 font-medium">
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </label>
        )}

        {type === "phone" ? (
          <CustomPhoneInput
            value={value}
            name={name}
            autoComplete={autoComplete}
            onChange={onChange}
            className={sharedClassName}
            {...props}
          />
        ) : type === "textarea" ? (
          <textarea
            ref={ref}
            autoComplete={autoComplete}
            placeholder={placeholder}
            value={value}
            name={name}
            onChange={onChange}
            {...props}
            className={sharedClassName}
          />
        ) : (
          <input
            ref={ref}
            autoComplete={autoComplete}
            type={type}
            placeholder={placeholder}
            value={value}
            name={name}
            onChange={onChange}
            {...props}
            className={sharedClassName}
          />
        )}

        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      </div>
    );
  },
);

FormInput.displayName = "FormInput";

export default FormInput;
